// extracted by mini-css-extract-plugin
export default {"label":"search-bar_label__m19jA"};